
import PaymentLegalNotices from '@/components/PaymentLegalNotices.vue'
import {
  formatEuros,
  instalmentPlans,
  oneyMinimumAbove,
  PRODUCT_INSTALMENTS_ONEY,
  PRODUCT_INSTALMENTS_PAYPAL_CREDIT,
  PRODUCT_INSTALMENTS_PAYPAL_IN_FOUR,
  productInstalments,
} from '@/utils/paymentOffers'

const LOGOS = {
  oney: {
    src: require('~/assets/images/payment_oney.png'),
    alt: 'Oney',
    height: 'tw-h-4',
  },
  paypal: {
    src: require('~/assets/images/payment_paypal2.png'),
    alt: 'PayPal',
    height: 'tw-h-3.5',
  },
}

export default {
  name: 'InstalmentOfferLine',
  components: {
    PaymentLegalNotices,
  },
  props: {
    amount: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      open: false,
      logos: LOGOS,
    }
  },
  computed: {
    offers() {
      return this.$store.getters.payment_offers
    },
    instalments() {
      return productInstalments(this.offers, this.amount)
    },
    plans() {
      return instalmentPlans(this.offers, this.amount)
    },
    providers() {
      return [...new Set(this.plans.map(({ provider }) => provider))]
    },
    oneyMinimum() {
      return oneyMinimumAbove(this.offers, this.amount)
    },
    title() {
      switch (this.instalments?.kind) {
        case PRODUCT_INSTALMENTS_ONEY:
          return this.$t('components.instalmentOfferLine.oneyTitle')
        case PRODUCT_INSTALMENTS_PAYPAL_IN_FOUR:
          return this.$t('components.instalmentOfferLine.paypalInFourTitle')
        case PRODUCT_INSTALMENTS_PAYPAL_CREDIT:
          return this.$t('components.instalmentOfferLine.paypalCreditTitle')
        default:
          return null
      }
    },
    amounts() {
      switch (this.instalments?.kind) {
        case PRODUCT_INSTALMENTS_ONEY:
          return this.$t('components.instalmentOfferLine.oneyAmounts', {
            three: this.price(this.instalments.three),
            four: this.price(this.instalments.four),
          })
        case PRODUCT_INSTALMENTS_PAYPAL_IN_FOUR:
          return this.$t('components.instalmentOfferLine.paypalInFourAmounts', {
            four: this.price(this.instalments.four),
          })
        default:
          return null
      }
    },
    steps() {
      const kind = this.instalments?.kind
      const choose =
        kind === PRODUCT_INSTALMENTS_ONEY
          ? 'components.instalmentOfferLine.stepChooseOneyOrPaypal'
          : 'components.instalmentOfferLine.stepChoosePaypal'
      const pay = {
        [PRODUCT_INSTALMENTS_ONEY]:
          'components.instalmentOfferLine.stepFirstPaymentThreeOrFour',
        [PRODUCT_INSTALMENTS_PAYPAL_IN_FOUR]:
          'components.instalmentOfferLine.stepFirstPaymentFour',
        [PRODUCT_INSTALMENTS_PAYPAL_CREDIT]:
          'components.instalmentOfferLine.stepPaypalOffers',
      }[kind]

      return ['components.instalmentOfferLine.stepAddToCart', choose, pay]
    },
  },
  methods: {
    formatEuros,
    price(value) {
      return this.$options.filters.priceFormat(value)
    },
  },
}
